import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { configureStore } from "./store";
import "./font/Gellix/stylesheet.css";
import "./font/TheSansArab/stylesheet.css";
import './utils/i18n';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const store = configureStore();

root.render(
  <Provider store={store}>
    <App />
  </Provider>,
);
reportWebVitals();